import SmallHeadingComponent from "./SmallHeadingComponent"
import Button from "./Button"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"
import Accordion from "./Accordion"
import Link from "./Link"
import { useNavigate } from "react-router-dom"
import { InstructionComponentProps } from "./instruction/InstructionComponent"
import AppDownloadInstructions from "./instruction/patient/AppDownloadInstructions"
import UpdateAppInstructions from "./instruction/patient/UpdateAppInstructions"
import AppLoginInstructions from "./instruction/patient/AppLoginInstructions"
import ChangePasswordInstructions from "./instruction/patient/ChangePasswordInstructions"
import OuraSetupInstructions from "./instruction/patient/OuraSetupInstructions"
import OuraConnectInstructions from "./instruction/patient/OuraConnectInstructions"
import AppQuestionnaireInstructions from "./instruction/patient/AppQuestionnaireInstructions"
import DataSyncInstructions from "./instruction/patient/DataSyncInstructions"
import OuraSyncExplanationInstructions from "./instruction/patient/OuraSyncExplanationInstructions"
import AddPatientInstructions from "./instruction/professional/AddPatientInstructions"
import ReportLocationInstruction from "./instruction/professional/ReportLocationInstruction"
import ReportStructureInstruction from "./instruction/professional/ReportStructureInstruction"
import DeregisterReportsInstruction from "./instruction/professional/DeregisterReportsInstruction"
import Card from "./Card"
import ProfessionalHelpTutorialRegistrationView from "../view/ProfessionalHelpTutorialRegistrationView"

export const PatientHelpViews: InstructionComponentProps[] = [
    AppDownloadInstructions,
    UpdateAppInstructions,
    AppLoginInstructions,
    ChangePasswordInstructions,
    OuraSetupInstructions,
    OuraConnectInstructions,
    AppQuestionnaireInstructions,
    DataSyncInstructions,
    OuraSyncExplanationInstructions
]

export const ProfessionalHelpViews: InstructionComponentProps[] = [
    AddPatientInstructions,
    ReportLocationInstruction,
    ReportStructureInstruction,
    DeregisterReportsInstruction
]

export interface FAQContentProps {
    display?: "professional" | "patient"
}

function FAQContent(props: FAQContentProps) {
    const navigate = useNavigate()

    // Decide which heading text to display based on props.display
    let headingText = "Hilfe für Patient:innen"
    if (props.display === "professional") {
        headingText = "Hilfe für Ärzt:innen"
    }

    return (
        <Card fill={true}>
            <div className="flex flex-col space-y-8">
                
               
                <div className="flex">
                    <SmallHeadingComponent>
                        {headingText}
                    </SmallHeadingComponent>

                    {/* Patient button (only if display=undefined or "patient") */}
                    {(!props.display || props.display === "patient") && (
                        <div className="ml-auto">
                            <Button
                                onClick={() =>
                                    navigate(
                                        NavigationPaths[
                                            NAVIGATION_VIEW.PATIENT_HELP_VIEW_TUTORIAL
                                        ].path
                                    )
                                }
                            >
                                Kurzanleitung für Patient:innen
                            </Button>
                        </div>
                    )}
                    {/* Professional button (only if display=professional) */}
                    {(!props.display || props.display === "professional") && (
                        <div className="ml-auto">
                            <Button
                                onClick={() =>
                                    navigate(
                                        NavigationPaths[
                                            NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW_REGISTRATION
                                        ].path
                                    )
                                }
                            >
                                Registrierungsanleitung für Ärzt:innen
                            </Button>
                        </div>
                    )}

                   
                </div>

                <div>
                    Die folgenden Links sollen Ihnen helfen, die
                    DOOR Studie Plattform besser zu verstehen und Ihre Fragen
                    beantworten. Durch einen Klick auf den grünen Button rechts
                    oben können Sie durch die geführte Kurzanleitung mit der
                    Einrichtung starten.
                    <br />
                    <br />
                    Sollten Sie weitere Fragen haben, können Sie uns gerne
                    kontaktieren:
                    <br />
                    <br />
                    <b>Mail:</b> <a href="mailto:door-hilfe@kl.cit.tum.de" className="text-blue-600 underline">
        door-hilfe@kl.cit.tum.de
    </a> (Antwortzeit:
                    werktags innerhalb von 48 Stunden)
                    <br />
                    <b>Telefon:</b> +49 89 954 5391 78 (Dienstag und Freitag,
                    14:00–18:00)
                </div>

                {/* Accordion for patient questions */}
                {(!props.display || props.display === "patient") && (
                    <Accordion
                        initial={props.display !== undefined}
                        title="Von Patient:innen häufig gestellte Fragen"
                    >
                        {PatientHelpViews.map((p) => (
                            <Link key={p.path} to={p.path}>
                                {p.name}
                            </Link>
                        ))}
                    </Accordion>
                )}

                {/* Accordion for professional questions */}
                {(!props.display || props.display === "professional") && (
                    <Accordion
                        initial={props.display !== undefined}
                        title="Von Ärzt:innen häufig gestellte Fragen"
                    >
                        {ProfessionalHelpViews.map((p) => (
                            <Link key={p.path} to={p.path}>
                                {p.name}
                            </Link>
                        ))}
                    </Accordion>
                )}
            </div>
        </Card>
    )
}

export default FAQContent
